var _rect, _mask, _path, _mask2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 8 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 5,
    height: 10,
    fill: "url(#paint0_linear_82_2)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_82_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5C17 9.61624 16.7801 10.7215 16.353 11.7528C15.9258 12.7841 15.2997 13.7211 14.5104 14.5104C13.7211 15.2997 12.7841 15.9258 11.7528 16.353C10.7215 16.7801 9.61624 17 8.5 17C7.38376 17 6.27846 16.7801 5.24719 16.353C4.21592 15.9258 3.27889 15.2997 2.48959 14.5104C1.70029 13.7211 1.07419 12.7841 0.647024 11.7528C0.219859 10.7215 -9.75844e-08 9.61624 0 8.5L3.91501 8.5C3.91501 9.10211 4.03361 9.69832 4.26403 10.2546C4.49444 10.8109 4.83217 11.3163 5.25793 11.7421C5.68368 12.1678 6.18913 12.5056 6.7454 12.736C7.30168 12.9664 7.89789 13.085 8.5 13.085C9.10211 13.085 9.69832 12.9664 10.2546 12.736C10.8109 12.5056 11.3163 12.1678 11.7421 11.7421C12.1678 11.3163 12.5056 10.8109 12.736 10.2546C12.9664 9.69832 13.085 9.10211 13.085 8.5H17Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5C17 9.61624 16.7801 10.7215 16.353 11.7528C15.9258 12.7841 15.2997 13.7211 14.5104 14.5104C13.7211 15.2997 12.7841 15.9258 11.7528 16.353C10.7215 16.7801 9.61624 17 8.5 17C7.38376 17 6.27846 16.7801 5.24719 16.353C4.21592 15.9258 3.27889 15.2997 2.48959 14.5104C1.70029 13.7211 1.07419 12.7841 0.647024 11.7528C0.219859 10.7215 -9.75844e-08 9.61624 0 8.5L3.91501 8.5C3.91501 9.10211 4.03361 9.69832 4.26403 10.2546C4.49444 10.8109 4.83217 11.3163 5.25793 11.7421C5.68368 12.1678 6.18913 12.5056 6.7454 12.736C7.30168 12.9664 7.89789 13.085 8.5 13.085C9.10211 13.085 9.69832 12.9664 10.2546 12.736C10.8109 12.5056 11.3163 12.1678 11.7421 11.7421C12.1678 11.3163 12.5056 10.8109 12.736 10.2546C12.9664 9.69832 13.085 9.10211 13.085 8.5H17Z",
    stroke: "url(#paint1_linear_82_2)",
    strokeWidth: 8,
    mask: "url(#path-2-inside-1_82_2)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_82_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43094e-07 32.5C8.40678e-07 31.3838 0.219859 30.2785 0.647025 29.2472C1.07419 28.2159 1.7003 27.2789 2.48959 26.4896C3.27889 25.7003 4.21592 25.0742 5.24719 24.647C6.27846 24.2199 7.38377 24 8.5 24C9.61624 24 10.7215 24.2199 11.7528 24.647C12.7841 25.0742 13.7211 25.7003 14.5104 26.4896C15.2997 27.2789 15.9258 28.2159 16.353 29.2472C16.7801 30.2785 17 31.3838 17 32.5L13.085 32.5C13.085 31.8979 12.9664 31.3017 12.736 30.7454C12.5056 30.1891 12.1678 29.6837 11.7421 29.2579C11.3163 28.8322 10.8109 28.4944 10.2546 28.264C9.69832 28.0336 9.10211 27.915 8.5 27.915C7.89789 27.915 7.30168 28.0336 6.7454 28.264C6.18913 28.4944 5.68368 28.8322 5.25793 29.2579C4.83217 29.6837 4.49444 30.1891 4.26403 30.7454C4.03361 31.3017 3.91502 31.8979 3.91502 32.5L7.43094e-07 32.5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43094e-07 32.5C8.40678e-07 31.3838 0.219859 30.2785 0.647025 29.2472C1.07419 28.2159 1.7003 27.2789 2.48959 26.4896C3.27889 25.7003 4.21592 25.0742 5.24719 24.647C6.27846 24.2199 7.38377 24 8.5 24C9.61624 24 10.7215 24.2199 11.7528 24.647C12.7841 25.0742 13.7211 25.7003 14.5104 26.4896C15.2997 27.2789 15.9258 28.2159 16.353 29.2472C16.7801 30.2785 17 31.3838 17 32.5L13.085 32.5C13.085 31.8979 12.9664 31.3017 12.736 30.7454C12.5056 30.1891 12.1678 29.6837 11.7421 29.2579C11.3163 28.8322 10.8109 28.4944 10.2546 28.264C9.69832 28.0336 9.10211 27.915 8.5 27.915C7.89789 27.915 7.30168 28.0336 6.7454 28.264C6.18913 28.4944 5.68368 28.8322 5.25793 29.2579C4.83217 29.6837 4.49444 30.1891 4.26403 30.7454C4.03361 31.3017 3.91502 31.8979 3.91502 32.5L7.43094e-07 32.5Z",
    stroke: "url(#paint2_linear_82_2)",
    strokeWidth: 8,
    mask: "url(#path-3-inside-2_82_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_2",
    x1: 8.5,
    y1: 15,
    x2: 8.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F10B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E56B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_82_2",
    x1: 14,
    y1: 17,
    x2: 0.00000114301,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#275BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8609B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_82_2",
    x1: 3,
    y1: 24,
    x2: 17,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#275BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8609B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.6302aee5f774c10783de2bb5873688b1.svg";
export { ForwardRef as ReactComponent };